import { FC, useEffect, useState } from 'react'

import { Button, ButtonGroup } from 'ui'
import { ClearButton } from '.'
import { useSelectedOptionsCount } from './hooks'
import { MFilters } from 'types/filterTypes'
import { Badge } from 'ui'

type FilterCollapsableProps = {
  contentName: MFilters.ContentTypes
  title: JSX.Element
  children: (props: { closeDropdown?: () => void; isOpen?: boolean }) => JSX.Element
  show: boolean
  noPadding?: boolean
  clearButton: boolean
  type: string
}

const FilterCollapsable: FC<FilterCollapsableProps> = ({ children, show, title, type, contentName, noPadding, clearButton }) => {
  const count = useSelectedOptionsCount({ contentName, heroFilter: type })
  const [isOpen, setIsOpen] = useState(false)

  // Look for the change of value of show to open or close the collapsables
  useEffect(() => {
    if (show) setIsOpen(true)
    else setIsOpen(false)
  }, [show])

  return (
    <div className="collapse-container mb-2">
      <ButtonGroup className="w-100">
        <Button
          className={`link-toggle toggle-header shadow-none d-flex justify-content-between align-items-center btn w-100`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="d-flex flex-row align-items-baseline">
            <h6>{title}</h6>
            {count ? (
              <Badge variant="primary" className="ml-2">
                {count}
              </Badge>
            ) : null}
          </div>

          {isOpen ? <i className="fas fa-chevron-up"></i> : <i className="fas fa-chevron-down"></i>}
        </Button>
        {clearButton && count ? (
          <ClearButton className="btn btn-outline-secondary border-left" type={type} contentName={contentName} style={{ border: 'none', boxShadow: 'none' }} />
        ) : null}
      </ButtonGroup>
      {isOpen ? (
        <div className={`${noPadding ? '' : 'p-3'}`}>
          <div>{children({ isOpen })}</div>
        </div>
      ) : null}
    </div>
  )
}

export default FilterCollapsable
